<template>
  <div data-name="final-score-page-wrapper" :class="$style.wrapper">
    <div data-name="final-score-page-container" :class="$style.container">
      <header-bar :class="$style.header" :hideMoreInfoButton="false"></header-bar>
      <div v-html="content" :class="$style.content"></div>

      <div :class="$style.hashtagContainer">#WhyImPrepared</div>

      <testimonial-button
        :class="$style['testimonial-button']"
        v-show="testimonial"
        ref="testimonialWrapper"
        :testimonial="testimonial"
        title="Click to show all testimonials"
        aria-label="Click to show all testimonials"
      ></testimonial-button>

      <ui-button
        v-if="isMobile"
        id="playAgainButton"
        :class="$style.button"
        :buttonAction="handleButtonClick('residential')"
        v-touch="handleButtonClick('residential')"
        :buttonText="this.selected == 'residential' ? 'Replay Residential' : 'View Residential'"
        title="Click to play again"
        aria-label="Click to play again"
      ></ui-button>

      <ui-button
        v-if="isMobile"
        id="playAgainButton"
        :class="$style.button"
        :buttonAction="handleButtonClick('commercial')"
        v-touch="handleButtonClick('commercial')"
        :buttonText="this.selected == 'commercial' ? 'Replay Commercial' : 'View Commercial'"
        title="Click to play again"
        aria-label="Click to play again"
      ></ui-button>

      <social-bar
        :content_top="social_top"
        :content_bottom="social_bottom"
        :facebook="facebook"
        :twitter="twitter"
      ></social-bar>
    </div>
  </div>
</template>

<script>
import HeaderBar from "../HeaderBar.vue";
import FinalScore from "../FinalScore.vue";
import UiButton from "../UiButton.vue";
import SocialBar from "../SocialBar.vue";
import TestimonialButton from "../TestimonialButton";
import exampleStore from "../../assets/ExampleStoreData.js";
import axios from "axios";
import isMobileMixin from "../../plugins/isMobileMixin.js";

export default {
  name: "final-score-page",
  components: { HeaderBar, FinalScore, UiButton, SocialBar, TestimonialButton },
  mixins: [isMobileMixin],
  props: [],
  data() {
    return {
      // roomsData: exampleStore,
      content: "",
      social_top: "",
      social_bottom: "",
      facebook: "",
      twitter: "",
      testimonial: ""
      // totalScore: 190
    };
  },
  computed: {
    totalScore: function() {
      return this.$store.getters.getTotalQuestionsCorrect;
    },
    finalScoreRoomsData: function() {
      return this.$store.getters.getFinalScoreRoomsData;
    },
    selected: function() {
      return this.$store.getters.getSelected;
    }
  },
  mounted() {
    // console.log(roomsData);
  },

  beforeCreate() {
    axios.get("/static/info.json").then(response => {
      // probably not the best way
      this.content = response.data.finalscore.content;
      this.social_top = response.data.finalscore.social_top;
      this.social_bottom = response.data.finalscore.social_bottom;
      this.facebook = response.data.finalscore.facebook;
      this.twitter = response.data.finalscore.twitter;
      this.testimonial = response.data.testimonials[0];
      // console.log(this.social);
    });
  },
  methods: {
    handleButtonClick: function() {
      // console.log('click being handled in FinalScorePage Component!');
      this.$store.dispatch("setAppStateForPlayAgain");
      this.$store.dispatch("setRoomsDataForPlayAgain");
    }
  }
};
</script>

<style lang='scss' module>
@import "../../assets/css/globals.scss";

.wrapper {
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1000;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: $sapGreen;
  overflow: hidden;
  box-sizing: border-box;

  padding-bottom: 40px;

  @include large {
    padding-bottom: 0px;

    // overflow-x: visible;
    // overflow-y: visible;
    overflow: hidden;

    -ms-overflow-style: none;

    width: 50%;
  }
}

.final-score {
  height: 100%;
}

.container {
  overflow-y: auto;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 32px;
  padding-right: 32px;
  box-sizing: border-box;

  @include large {
    // height: 100%;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    // flex-direction: column;

    padding-top: 65px;
    padding-bottom: 65px;
    padding-left: 65px;
    padding-right: 65px;
    // max-width: 800px;
  }
}

.header {
  position: static;
}

.content {
  padding-top: 20px;
  padding-bottom: 40px;
  border-bottom: 2px solid rgba($black, 0.1);
  box-sizing: border-box;
  width: 100%;

  color: $white;
  line-height: 1.5;
  font-size: 14px;

  a {
    color: $white;
    text-decoration: none;
  }

  @include large {
    font-size: 16px;
    padding-top: 40px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 40px;
  }
}

.button {
  width: 80%;
  height: auto;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 16px;
  padding-bottom: 16px;

  color: $white;
  font-size: 14px;
  font-weight: 600;

  opacity: 0;

  @include large {
    position: absolute;
    top: 50%;
    right: 150%;
    transform: translateY(-50%) translateX(125px);
    width: 250px;

    padding-left: 40px;
    padding-right: 40px;
  }
}

.testimonial-button {
  @include medium {
    width: 100%;
    // max-width: 285px;
  }

  @include xxxlarge {
    max-width: 500px;
  }
}

.hashtagContainer {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  padding-top: 20px;

  font-size: 30px;
  font-weight: bold;

  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FinalScorePage.vue